import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { MenuItem } from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import ButtonGroup from "@mui/material/ButtonGroup";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { collection, addDoc, getDocs } from "firebase/firestore";
import {db} from '../firebase';
import { storage } from '../firestore';
import {ref, uploadBytes } from "firebase/storage";
import Dropzone from 'react-dropzone';
import {useDropzone} from 'react-dropzone'
import { useCallback } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';



const gradoParentela = [
  {
    value: "Marito",
    label: "Marito",
  },
  {
    value: "Moglie",
    label: "Moglie",
  },
  {
    value: "Figlio (non sposato)",
    label: "Figlio (non sposato)",
  },
  {
    value: "Figlio (sposato)",
    label: "Figlio (sposato)",
  },
  {
    value: "Figlia (non sposata)",
    label: "Figlia (non sposata)",
  },
  {
    value: "Figlia (sposata)",
    label: "Figlia (sposata)",
  },
  {
    value: "Padre",
    label: "Padre",
  },
  {
    value: "Madre",
    label: "Madre",
  },
  {
    value: "Suocero",
    label: "Suocero",
  },
  {
    value: "Suocera",
    label: "Suocera",
  },
  {
    value: "Convivente",
    label: "Convivente",
  },
]

const status = [
  {
    value: "A-M",
    label: "Militare in servizio presso Accademia Aeronautica",
  },
  {
    value: "A-C",
    label: "Civile in servizio presso Accademia Aeronautica",
  },
  {
    value: "B-M",
    label: "Militare in servizio presso altro Ente A.M.",
  },
  {
    value: "B-C",
    label: "Civile in servizio presso altro Ente A.M.",
  },
  {
    value: "C",
    label: "Coniuge superstite del personale Militare o Civile dell' A.M.",
  },
  {
    value: "D-M",
    label: "Militare in servizio presso altri Enti Ministero della Difesa",
  },
  {
    value: "D-C",
    label: "Civile in servizio presso altri Enti Ministero della Difesa",
  },
  {
    value: "E",
    label: "Militare o Civile in quiescenza già in forza all'Accademia Aeronautica",
  },
  {
    value: "F",
    label: "Militare o Civile in quiescenza già in forza ad altro Ente Ministero Difesa",
  },
  {
    value: "G",
    label: "Coniuge superstite del personale Militare o Civile (in servizio o in quiescenza) del Ministero della Difesa",
  },
  {
    value: "H",
    label: "Personale in servizio attivo dei Corpi Armati e militarmente organizzati dello Stato (P.S., G.d.F., Polizia Penitenziaria, VV.FF.) e Corpi Ausiliari delle FF.AA. (Croce Rossa Italiana)",
  },
  {
    value: "I",
    label: "Personale in serivzio presso altri Ministeri, Enti Statali, Regionali, Provinciali, Comunali",
  },
];

const numbersOfRequests = [
  {
    value: "0",
    label: "0",
  },
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
]

const Form = () => {

  const [openAttachmentsDialog, setOpenAttachmentsDialog] = React.useState(false);
  const [showUploader, setshowUploader] = React.useState(false);
  const handleClickChiudiUploader = () => {
    setshowUploader(false);
  };

  const handleClickOpenAttachmentsDialog = () => {
    setOpenAttachmentsDialog(true);
  };

  const handleCloseAttachmentsDialog = () => {
    setOpenAttachmentsDialog(false);
  };

  const verificaAttachmentsDomanda = () => {
    console.log("verificaAttachmentsDomanda");

    console.log("Codice to numbers");
    for (let i = 0; i < userAttachmentsRequestId.length; i++) {
     
      console.log(userAttachmentsRequestId.charAt(i).charCodeAt(0));
    }
    setMessaggioUploaded("");
    fetchDocs();
  };

 
  const fetchDocs = async () => {
    console.log("fetchDocs");
    console.log(userAttachmentsEmail.toLowerCase() + " " + userAttachmentsRequestId + " " + userAttachmentsOTP);
    await getDocs(collection(db, "AreaDocumenti2026"))
        .then((querySnapshot)=>{              
            const newData = querySnapshot.docs.map((doc) => ({...doc.data()}));
            var trovata = false;
            console.log("fetchDocs querySnapshot");
            querySnapshot.forEach(documentSnapshot => {
              console.log("fetchDocs querySnapshot forEach");
              const rowData = documentSnapshot.data();
           
              if(rowData.email.toLowerCase() === userAttachmentsEmail.toLowerCase() && rowData.idRichiesta === userAttachmentsRequestId && rowData.OTP === userAttachmentsOTP){
                trovata = true;
                console.log("fetchDocs querySnapshot forEach trovata");
              }
            }
           );
           if(trovata === false){

           }else{
              setOpenAttachmentsDialog(false);
              setshowUploader(true);
           }
           return;
        })
       
    }

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const verificaDomanda = () => {
    if(verificaDomandaFieldError === false){
      setOpenDialog(false);
      fetchPost();
    }
   
  };
   const fetchPost = async () => {
      await getDocs(collection(db, "Richieste2026"))
          .then((querySnapshot)=>{              
              const newData = querySnapshot.docs.map((doc) => ({...doc.data()}));
              var inviata = false;
              querySnapshot.forEach(documentSnapshot => {
                const rowData = documentSnapshot.data();
                if(rowData.emailTitolare.toLowerCase() === verificaDomandaField.toLowerCase()){
                  //console.log(documentSnapshot.id);
                  //console.log(rowData);

                  var toEmail = verificaDomandaField;
                  var messagePlain = "Gentile " + rowData.nomeTitolare.toUpperCase() + " " + rowData.cognomeTitolare.toUpperCase() + " ti confermiamo l'avvenuta ricezione della tua richiesta di abbonamento per la stagione estiva 2026. <br>Di seguito il codice identificativo della tua richiesta richiesta: <br>";
                  messagePlain += "<strong>" + documentSnapshot.id + "</strong>";
                  messagePlain += "<br><br>";
                  messagePlain += "Ti ricordiamo che entro il 20 Giugno 2026 riceverai comunicazione relativa la valutazione della tua domanda.";
                  messagePlain += "<br><br>";
                  messagePlain += "Il Gestore";

                  var messageHtml = "Gentile " + rowData.nomeTitolare.toUpperCase() + " " + rowData.cognomeTitolare.toUpperCase() + " ti confermiamo l'avvenuta ricezione della tua richiesta di abbonamento per la stagione estiva 2026. <br>Di seguito il codice identificativo della tua richiesta richiesta: <br>";
                  messageHtml += "<strong>" + documentSnapshot.id + "</strong>";
                  messageHtml += "<br><br>";
                  messageHtml += "Ti ricordiamo che entro il 20 Giugno 2026 riceverai comunicazione relativa la valutazione della tua domanda.";
                  messageHtml += "<br><br>";
                  messageHtml += "Il Gestore";
                  
                  sendEmailConfirm(messageHtml, messagePlain, toEmail);
                  inviata = true;
                }
              }
             );
             if(inviata === false){
              
             }else{

             }
             setVerificaDomandaField("");
          })
     
  }

  const [userAttachmentsEmail, setUserAttachmentsEmail] = useState("");
  const [userAttachmentsRequestId, setUserAttachmentsRequestId] = useState("");
  const [userAttachmentsOTP, setUserAttachmentsOTP] = useState("");
  const handleUserAttachmentsEmailChange = e => {
    setUserAttachmentsEmail(e.target.value);
  }
  const handleUserAttachmentsRequestIdChange = e => {
    setUserAttachmentsRequestId(e.target.value);
  }
  const handleUserAttachmentsOTPChange = e => {
    setUserAttachmentsOTP(e.target.value);
  }

  const [verificaDomandaField, setVerificaDomandaField] = useState("");
  const [verificaDomandaFieldError, setVerificaDomandaFieldError] = useState(false);
  const handleVerificaDomandaFieldChange = e => {
  setVerificaDomandaField(e.target.value);
  if (e.target.validity.valid) {
    setVerificaDomandaFieldError(false);
  } else {
    setVerificaDomandaFieldError(true);
  }
}

  const [openLoader, setOpenLoader] = React.useState(false);
  const handleOpenLoader = () => setOpenLoader(true);
  const handleCloseLoader = () => setOpenLoader(false);

  const [messaggioServer, setMessaggioServer] = useState("")
  const [nuovaRichiesta, setNuovaRichiesta] = useState("test")

  async function sendEmailConfirm(messageHtml, messagePlain, toEmail){
    try {
    const docRef = await addDoc(collection(db, "mail"), {

      to: toEmail,
      message: {
        subject: "Distaccamento Straordinario A.M. di \"Miliscola\" - Campagna Abbonamenti 2026",
        text: messagePlain,
        html: messageHtml, //"This is the <code>HTML</code> section of the email body.",
      } });
      //console.log("Queued email for delivery!")
  } catch (e) {
    console.error("Error adding document: ", e);
  }
  }
  
  async function writeToDB() {
    //console.log("writeToDB");

    handleOpenLoader();

    try {
        const docRef = await addDoc(collection(db, "Richieste2026"), {
          nomeTitolare: name.toUpperCase(),
          cognomeTitolare: lastName.toUpperCase(),
          dataNascitaTitolare: bDay,
          cittaDiNascitaTitolare: bCity.toUpperCase(),
          provinciaDiNascitaTitolare: bCountry.toUpperCase(),
          nazioneDiNascitaTitolare: bProv.toUpperCase(),
          emailTitolare: email,
          categoriaDiAppartenenza: selectedStatus,
          gradoTitolare: grado.toUpperCase(),
          cmdTitolare: cmd.toUpperCase(),
          enteDiservizioTitolare: enteDiServizio.toUpperCase(),
          ultimoEnteDiServizioTitolare: ultimoEnteDiServizio.toUpperCase(),
          nomeCognomeDefunto: nomeCognomeDefuntoStatus.toUpperCase(),
          estremiDocumento: estremiDocStatus.toUpperCase(),
          turnoGiugno: (selectedGiugno === 1 ? "SI" : "NO"),
          prioritaTurnoGiugno: selectedGiugnoP,
          turnoLuglio: (selectedLuglio === 1 ? "SI" : "NO"),
          prioritaTurnoLuglio: selectedLuglioP,
          turnoAgosto: (selectedAgosto === 1 ? "SI" : "NO"),
          prioritaTurnoAgosto: selectedAgostoP,
          turnoSettembre: (selectedSettembre === 1 ? "SI" : "NO"),
          prioritaTurnoSettembre: selectedSettembreP,
          figliFinoA12:figliMinorenni,
          numeroAltriAbbonamenti:numberOfParents,
          gradoParentelaEA1: gradoParentelaEA1.toUpperCase(),
          nomeCognomeEA1: nomeCognomeEA1.toUpperCase(),
          etaEA1: etaEA1,
          noteEA1: noteEA1.toUpperCase(),
          gradoParentelaEA2: gradoParentelaEA2.toUpperCase(),
          nomeCognomeEA2: nomeCognomeEA2.toUpperCase(),
          etaEA2: etaEA2,
          noteEA2: noteEA2.toUpperCase(),
          gradoParentelaEA3: gradoParentelaEA3.toUpperCase(),
          nomeCognomeEA3: nomeCognomeEA3.toUpperCase(),
          etaEA3: etaEA3,
          noteEA3: noteEA3.toUpperCase(),
          gradoParentelaEA4: gradoParentelaEA4.toUpperCase(),
          nomeCognomeEA4: nomeCognomeEA4.toUpperCase(),
          etaEA4: etaEA4,
          noteEA4: noteEA4.toUpperCase(),
          gradoParentelaEA5: gradoParentelaEA5.toUpperCase(),
          nomeCognomeEA5: nomeCognomeEA5.toUpperCase(),
          etaEA5: etaEA5,
          noteEA5: noteEA5.toUpperCase(),
          gradoParentelaEA6: gradoParentelaEA6.toUpperCase(),
          nomeCognomeEA6: nomeCognomeEA6.toUpperCase(),
          etaEA6: etaEA6,
          noteEA6: noteEA6.toUpperCase(),
          gradoParentelaEA7: gradoParentelaEA7.toUpperCase(),
          nomeCognomeEA7: nomeCognomeEA7.toUpperCase(),
          etaEA7: etaEA7,
          noteEA7: noteEA7.toUpperCase(),
          gradoParentelaEA8: gradoParentelaEA8.toUpperCase(),
          nomeCognomeEA8: nomeCognomeEA8.toUpperCase(),
          etaEA8: etaEA8,
          noteEA8: noteEA8.toUpperCase(),
          gradoParentelaEA9: gradoParentelaEA9.toUpperCase(),
          nomeCognomeEA9: nomeCognomeEA9.toUpperCase(),
          etaEA9: etaEA9,
          noteEA9: noteEA9.toUpperCase(),
          gradoParentelaEA10: gradoParentelaEA10.toUpperCase(),
          nomeCognomeEA10: nomeCognomeEA10.toUpperCase(),
          etaEA10: etaEA10,
          noteEA10: noteEA10.toUpperCase(),
          stato: "nuova"
        });
        //console.log("Document written with ID: ", docRef.id);

        var toEmail = email;
        var messagePlain = "Gentile " + name.toUpperCase() + " " + lastName.toUpperCase() + " ti confermiamo l'avvenuta ricezione della tua richiesta di abbonamento per la stagione estiva 2026. <br>Di seguito il codice identificativo della tua richiesta richiesta: <br>";
        messagePlain += "<strong>" + docRef.id + "</strong>";
        messagePlain += "<br><br>";
        messagePlain += "Ti ricordiamo che entro il 25 Giugno 2026 riceverai comunicazione relativa la valutazione della tua domanda.";
        messagePlain += "<br><br>";
        messagePlain += "Il Gestore";

        var messageHtml = "Gentile " + name.toUpperCase() + " " + lastName.toUpperCase() + " ti confermiamo l'avvenuta ricezione della tua richiesta di abbonamento per la stagione estiva 2026. <br>Di seguito il codice identificativo della tua richiesta richiesta: <br>";
        messageHtml += "<strong>" + docRef.id + "</strong>";
        messageHtml += "<br><br>";
        messageHtml += "Ti ricordiamo che entro il 25 Giugno 2026 riceverai comunicazione relativa la valutazione della tua domanda.";
        messageHtml += "<br><br>";
        messageHtml += "Il Gestore";
        
        sendEmailConfirm(messageHtml, messagePlain, toEmail);


        setMessaggioServer("La tua richiesta è stata inviata con successo. Il tuo codice richiesta è " + docRef.id + ". Riceverai una mail di conferma entro 24 ore.")
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        handleCloseLoader();
      } catch (e) {
        console.error("Error adding document: ", e);
        setMessaggioServer("Non è stato possibile inviare la tua richiesta. Riprova più tardi");
        handleCloseLoader();
      }
}

  const [showGrado, setShowGrado] = useState(false);
  const [showCMD, setShowCMD] = useState(false);
  const [showEnteDiServizio, setShowEnteDiServizio] = useState(false);
  const [showUltimoEnteDiServizio, setShowUltimoEnteDiServizio] = useState(false);
  const [showEstremiDocStatus, setShowEstremiDocStatus] = useState(false);
  const [showNomeCognomeDefuntoStatus, setShowNomeCognomeDefuntoStatus] = useState(false);


  // Grado
  const [grado, setGrado] = useState("");
  const [gradoError, setGradoError] = useState(false);
  const handleGradoChange = e => {
    setGrado(e.target.value);
    if (e.target.validity.valid) {
      setGradoError(false);
    } else {
      setGradoError(true);
    }
  };

  // CMD
  const [cmd, setCmd] = useState("");
  const [cmdError, setCmdError] = useState(false);
  const handleCmdChange = e => {
    setCmd(e.target.value);
    if (e.target.validity.valid) {
      setCmdError(false);
    } else {
      setCmdError(true);
    }
  };

  // Ente di Servizio
  const [enteDiServizio, setEnteDiServizio] = useState("");
  const [enteDiServizioError, setEnteDiServizioError] = useState(false);
  const handleEnteDiServizioChange = e => {
    setEnteDiServizio(e.target.value);
    if (e.target.validity.valid) {
      setEnteDiServizioError(false);
    } else {
      setEnteDiServizioError(true);
    }
  };

  // Ultimo Ente Di Servizio
  const [ultimoEnteDiServizio, setUltimoEnteDiServizio] = useState("");
  const [ultimoEnteDiServizioError, setUltimoEnteDiServizioError] = useState(false);
  const handleUltimoEnteDiServizioChange = e => {
    setUltimoEnteDiServizio(e.target.value);
    if (e.target.validity.valid) {
      setUltimoEnteDiServizioError(false);
    } else {
      setUltimoEnteDiServizioError(true);
    }
  };

// Estremi documento
const [estremiDocStatus, setEstremiDocStatus] = useState("");
const [estremiDocStatusError, setEstremiDocStatusError] = useState(false);
const handleEstremiDocStatusChange = e => {
  setEstremiDocStatus(e.target.value);
  if (e.target.validity.valid) {
    setEstremiDocStatusError(false);
  } else {
    setEstremiDocStatusError(true);
  }
};

// Nome e Cognome del Defunto
const [nomeCognomeDefuntoStatus, setNomeCognomeDefuntoStatus] = useState("");
const [nomeCognomeDefuntoStatusError, setNomeCognomeDefuntoStatusError] = useState(false);
const handlenomeCognomeDefuntoStatusChange = e => {
  setNomeCognomeDefuntoStatus(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeDefuntoStatusError(false);
  } else {
    setNomeCognomeDefuntoStatusError(true);
  }
};

  // Nome
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const handleNameChange = e => {
    setName(e.target.value);
    if (e.target.validity.valid) {
      setNameError(false);
    } else {
      setNameError(true);
    }
  };

  // Cognome
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState(false);
  const handleLastNameChange = e => {
    setLastName(e.target.value);
    if (e.target.validity.valid) {
      setLastNameError(false);
    } else {
      setLastNameError(true);
    }
  };

  // Città di Nascita
  const [bCity, setbCity] = useState("");
  const [bCityError, setbCityError] = useState(false);
  const handlebCityChange = e => {
    setbCity(e.target.value);
    if (e.target.validity.valid) {
      setbCityError(false);
    } else {
      setbCityError(true);
    }
  };

  // Provincia di Nascita
  const [bProv, setbProv] = useState("");
  const [bProvError, setbProvError] = useState(false);
  const handlebProvChange = e => {
    setbProv(e.target.value);
    if (e.target.validity.valid) {
      setbProvError(false);
    } else {
      setbProvError(true);
    }
  };

  // Nazione di Nascita
  const [bCountry, setbCountry] = useState("");
  const [bCountryError, setbCountryError] = useState(false);
  const handlebCountryChange = e => {
    setbCountry(e.target.value);
    if (e.target.validity.valid) {
      setbCountryError(false);
    } else {
      setbCountryError(true);
    }
  };

  // Email
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const handleEmailChange = e => {
  setEmail(e.target.value);
  if (e.target.validity.valid) {
    setEmailError(false);
  } else {
    setEmailError(true);
  }
}

// Giugno
const [selectedGiugno, setSelectedGiugno] = useState("");
const [selectedGiugnoError, setSelectedGiugnoError] = useState(false);
const handleGiugnoSelectedChange = e => {
  setSelectedGiugno(e.target.value);
}

const [selectedGiugnoP, setSelectedGiugnoP] = useState("");
const [selectedGiugnoPError, setSelectedGiugnoPError] = useState(false);
const handleGiugnoPSelectedChange = e => {
  setSelectedGiugnoP(e.target.value);
}


// Luglio
const [selectedLuglio, setSelectedLuglio] = useState("");
const [selectedLuglioError, setSelectedLuglioError] = useState(false);
const handleLuglioSelectedChange = e => {
  setSelectedLuglio(e.target.value);
}

const [selectedLuglioP, setSelectedLuglioP] = useState("");
const [selectedLuglioPError, setSelectedLuglioPError] = useState(false);
const handleLuglioPSelectedChange = e => {
  setSelectedLuglioP(e.target.value);
}

// Agosto
const [selectedAgosto, setSelectedAgosto] = useState("");
const [selectedAgostoError, setSelectedAgostoError] = useState(false);
const handleAgostoSelectedChange = e => {
  setSelectedAgosto(e.target.value);
}

const [selectedAgostoP, setSelectedAgostoP] = useState("");
const [selectedAgostoPError, setSelectedAgostoPError] = useState(false);
const handleAgostoPSelectedChange = e => {
  setSelectedAgostoP(e.target.value);
}

// Settembre
const [selectedSettembre, setSelectedSettembre] = useState("");
const [selectedSettembreError, setSelectedSettembreError] = useState(false);
const handleSettembreSelectedChange = e => {
  setSelectedSettembre(e.target.value);
}

const [selectedSettembreP, setSelectedSettembreP] = useState("");
const [selectedSettembrePError, setSelectedSettembrePError] = useState(false);
const handleSettembrePSelectedChange = e => {
  setSelectedSettembreP(e.target.value);
}

// Figli minorenni
const [figliMinorenni, setFigliMinorenni] = useState(0);
const [figliMinorenniError, setFigliMinorenniError] = useState(false);
const handlesetFigliMinorenniChange = e => {
  setFigliMinorenni(e.target.value);
}
// Numero Abbonamenti
const [numberOfParents, setNumberOfParents] = useState(0);
const [numberOfParentsError, setNumberOfParentsError] = useState(false);
const handleNumberOfParentsChange = e => {
  setNumberOfParents(e.target.value);
}

// Extra Abbonamento 1 /////////////////////////////////////////////////////
const [gradoParentelaEA1, setGradoParentelaEA1] = useState("");
const [gradoParentelaEA1Error, setGradoParentelaEA1Error] = useState(false);
const handleGradoParentelaEA1Change = e => {
  setGradoParentelaEA1(e.target.value);
  if (e.target.value === "") {
    setGradoParentelaEA1Error(true);
  } else {
    setGradoParentelaEA1Error(false);
  }
}

const [nomeCognomeEA1, setNomeCognomeEA1] = useState("");
const [nomeCognomeEA1Error, setNomeCognomeEA1Error] = useState(false);
const handleNomeCognomeEA1Change = e => {
  setNomeCognomeEA1(e.target.value);
  if (e.target.value === "") {
    setNomeCognomeEA1Error(true);
  } else {
    setNomeCognomeEA1Error(false);
  }
};

const [etaEA1, setEtaEA1] = useState("");
const [etaEA1Error, setEtaEA1Error] = useState(false);
const handleEtaEA1Change = e => {
  setEtaEA1(e.target.value);
  if (e.target.value === "") {
    setEtaEA1Error(true);
  } else {
    setEtaEA1Error(false);
  }
}

const [noteEA1, setNoteEA1] = useState("");
const handleNoteEA1Change = e => {
  setNoteEA1(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 2 /////////////////////////////////////////////////////
const [gradoParentelaEA2, setGradoParentelaEA2] = useState("");
const [gradoParentelaEA2Error, setGradoParentelaEA2Error] = useState(false);
const handleGradoParentelaEA2Change = e => {
  setGradoParentelaEA2(e.target.value);
}

const [nomeCognomeEA2, setNomeCognomeEA2] = useState("");
const [nomeCognomeEA2Error, setNomeCognomeEA2Error] = useState(false);
const handleNomeCognomeEA2Change = e => {
  setNomeCognomeEA2(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA2Error(false);
  } else {
    setNomeCognomeEA2Error(true);
  }
};

const [etaEA2, setEtaEA2] = useState("");
const [etaEA2Error, setEtaEA2Error] = useState(false);
const handleEtaEA2Change = e => {
  setEtaEA2(e.target.value);
}

const [noteEA2, setNoteEA2] = useState("");
const handleNoteEA2Change = e => {
  setNoteEA2(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 3 /////////////////////////////////////////////////////
const [gradoParentelaEA3, setGradoParentelaEA3] = useState("");
const [gradoParentelaEA3Error, setGradoParentelaEA3Error] = useState(false);
const handleGradoParentelaEA3Change = e => {
  setGradoParentelaEA3(e.target.value);
}

const [nomeCognomeEA3, setNomeCognomeEA3] = useState("");
const [nomeCognomeEA3Error, setNomeCognomeEA3Error] = useState(false);
const handleNomeCognomeEA3Change = e => {
  setNomeCognomeEA3(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA3Error(false);
  } else {
    setNomeCognomeEA3Error(true);
  }
};

const [etaEA3, setEtaEA3] = useState("");
const [etaEA3Error, setEtaEA3Error] = useState(false);
const handleEtaEA3Change = e => {
  setEtaEA3(e.target.value);
}

const [noteEA3, setNoteEA3] = useState("");
const handleNoteEA3Change = e => {
  setNoteEA3(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 4 /////////////////////////////////////////////////////
const [gradoParentelaEA4, setGradoParentelaEA4] = useState("");
const [gradoParentelaEA4Error, setGradoParentelaEA4Error] = useState(false);
const handleGradoParentelaEA4Change = e => {
  setGradoParentelaEA4(e.target.value);
}

const [nomeCognomeEA4, setNomeCognomeEA4] = useState("");
const [nomeCognomeEA4Error, setNomeCognomeEA4Error] = useState(false);
const handleNomeCognomeEA4Change = e => {
  setNomeCognomeEA4(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA4Error(false);
  } else {
    setNomeCognomeEA4Error(true);
  }
};

const [etaEA4, setEtaEA4] = useState("");
const [etaEA4Error, setEtaEA4Error] = useState(false);
const handleEtaEA4Change = e => {
  setEtaEA4(e.target.value);
}

const [noteEA4, setNoteEA4] = useState("");
const handleNoteEA4Change = e => {
  setNoteEA4(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 5 /////////////////////////////////////////////////////
const [gradoParentelaEA5, setGradoParentelaEA5] = useState("");
const [gradoParentelaEA5Error, setGradoParentelaEA5Error] = useState(false);
const handleGradoParentelaEA5Change = e => {
  setGradoParentelaEA5(e.target.value);
}

const [nomeCognomeEA5, setNomeCognomeEA5] = useState("");
const [nomeCognomeEA5Error, setNomeCognomeEA5Error] = useState(false);
const handleNomeCognomeEA5Change = e => {
  setNomeCognomeEA5(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA5Error(false);
  } else {
    setNomeCognomeEA5Error(true);
  }
};

const [etaEA5, setEtaEA5] = useState("");
const [etaEA5Error, setEtaEA5Error] = useState(false);
const handleEtaEA5Change = e => {
  setEtaEA5(e.target.value);
}

const [noteEA5, setNoteEA5] = useState("");
const handleNoteEA5Change = e => {
  setNoteEA5(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 6 /////////////////////////////////////////////////////
const [gradoParentelaEA6, setGradoParentelaEA6] = useState("");
const [gradoParentelaEA6Error, setGradoParentelaEA6Error] = useState(false);
const handleGradoParentelaEA6Change = e => {
  setGradoParentelaEA6(e.target.value);
}

const [nomeCognomeEA6, setNomeCognomeEA6] = useState("");
const [nomeCognomeEA6Error, setNomeCognomeEA6Error] = useState(false);
const handleNomeCognomeEA6Change = e => {
  setNomeCognomeEA6(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA6Error(false);
  } else {
    setNomeCognomeEA6Error(true);
  }
};

const [etaEA6, setEtaEA6] = useState("");
const [etaEA6Error, setEtaEA6Error] = useState(false);
const handleEtaEA6Change = e => {
  setEtaEA6(e.target.value);
}

const [noteEA6, setNoteEA6] = useState("");
const handleNoteEA6Change = e => {
  setNoteEA6(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 7 /////////////////////////////////////////////////////
const [gradoParentelaEA7, setGradoParentelaEA7] = useState("");
const [gradoParentelaEA7Error, setGradoParentelaEA7Error] = useState(false);
const handleGradoParentelaEA7Change = e => {
  setGradoParentelaEA7(e.target.value);
}

const [nomeCognomeEA7, setNomeCognomeEA7] = useState("");
const [nomeCognomeEA7Error, setNomeCognomeEA7Error] = useState(false);
const handleNomeCognomeEA7Change = e => {
  setNomeCognomeEA7(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA7Error(false);
  } else {
    setNomeCognomeEA7Error(true);
  }
};

const [etaEA7, setEtaEA7] = useState("");
const [etaEA7Error, setEtaEA7Error] = useState(false);
const handleEtaEA7Change = e => {
  setEtaEA7(e.target.value);
}

const [noteEA7, setNoteEA7] = useState("");
const handleNoteEA7Change = e => {
  setNoteEA7(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 8 /////////////////////////////////////////////////////
const [gradoParentelaEA8, setGradoParentelaEA8] = useState("");
const [gradoParentelaEA8Error, setGradoParentelaEA8Error] = useState(false);
const handleGradoParentelaEA8Change = e => {
  setGradoParentelaEA8(e.target.value);
}

const [nomeCognomeEA8, setNomeCognomeEA8] = useState("");
const [nomeCognomeEA8Error, setNomeCognomeEA8Error] = useState(false);
const handleNomeCognomeEA8Change = e => {
  setNomeCognomeEA8(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA8Error(false);
  } else {
    setNomeCognomeEA8Error(true);
  }
};

const [etaEA8, setEtaEA8] = useState("");
const [etaEA8Error, setEtaEA8Error] = useState(false);
const handleEtaEA8Change = e => {
  setEtaEA8(e.target.value);
}

const [noteEA8, setNoteEA8] = useState("");
const handleNoteEA8Change = e => {
  setNoteEA8(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 9 /////////////////////////////////////////////////////
const [gradoParentelaEA9, setGradoParentelaEA9] = useState("");
const [gradoParentelaEA9Error, setGradoParentelaEA9Error] = useState(false);
const handleGradoParentelaEA9Change = e => {
  setGradoParentelaEA9(e.target.value);
}

const [nomeCognomeEA9, setNomeCognomeEA9] = useState("");
const [nomeCognomeEA9Error, setNomeCognomeEA9Error] = useState(false);
const handleNomeCognomeEA9Change = e => {
  setNomeCognomeEA9(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA9Error(false);
  } else {
    setNomeCognomeEA9Error(true);
  }
};

const [etaEA9, setEtaEA9] = useState("");
const [etaEA9Error, setEtaEA9Error] = useState(false);
const handleEtaEA9Change = e => {
  setEtaEA9(e.target.value);
}

const [noteEA9, setNoteEA9] = useState("");
const handleNoteEA9Change = e => {
  setNoteEA9(e.target.value);
};

////////////////////////////////////////////////////////////////////////////
// Extra Abbonamento 10 /////////////////////////////////////////////////////
const [gradoParentelaEA10, setGradoParentelaEA10] = useState("");
const [gradoParentelaEA10Error, setGradoParentelaEA10Error] = useState(false);
const handleGradoParentelaEA10Change = e => {
  setGradoParentelaEA10(e.target.value);
}

const [nomeCognomeEA10, setNomeCognomeEA10] = useState("");
const [nomeCognomeEA10Error, setNomeCognomeEA10Error] = useState(false);
const handleNomeCognomeEA10Change = e => {
  setNomeCognomeEA10(e.target.value);
  if (e.target.validity.valid) {
    setNomeCognomeEA10Error(false);
  } else {
    setNomeCognomeEA10Error(true);
  }
};

const [etaEA10, setEtaEA10] = useState("");
const [etaEA10Error, setEtaEA10Error] = useState(false);
const handleEtaEA10Change = e => {
  setEtaEA10(e.target.value);
}

const [noteEA10, setNoteEA10] = useState("");
const handleNoteEA10Change = e => {
  setNoteEA10(e.target.value);
};

////////////////////////////////////////////////////////////////////////////

// Status
const [selectedStatus, setSelectedStatus] = useState("");
const [selectedStatusError, setSelectedStatusError] = useState(false);
const handleSelectedStatusChange = e => {
  setSelectedStatus(e.target.value);

  //console.log("handleSelectedStatusChange >>> " + e.target.value);

  // Visualizza Grado
  if( e.target.value === "A-M" ||
      e.target.value === "A-C" ||
      e.target.value === "B-M" ||
      e.target.value === "B-C" ||
      e.target.value === "D-M" ||
      e.target.value === "D-C" ||
      e.target.value === "H" ||
      e.target.value === "I" ||
      e.target.value === "E" ||
      e.target.value === "F"
  ){
    setShowGrado(true);
  }else{
    setShowGrado(false);
  }

  // Visualizza CMD
  if( e.target.value === "A-M" ||
      e.target.value === "A-C" ||
      e.target.value === "B-M" ||
      e.target.value === "B-C" ||
      e.target.value === "D-M" ||
      e.target.value === "D-C" 
  ){
    setShowCMD(true);
  }else{
    setShowCMD(false);
  }

  // Visualizza Ente
  if( 
    e.target.value === "B-M" ||
    e.target.value === "B-C" ||
    e.target.value === "D-M" ||
    e.target.value === "D-C" ||
    e.target.value === "H" ||
    e.target.value === "I"
  ){
    setShowEnteDiServizio(true);
  }else{
    setShowEnteDiServizio(false);
  }

  // Visualizza Estremi
  if( 
    e.target.value === "C" ||
    e.target.value === "G" ||
    e.target.value === "H" ||
    e.target.value === "I" ||
    e.target.value === "E" ||
    e.target.value === "F"
  ){
    setShowEstremiDocStatus(true);
    setShowUltimoEnteDiServizio(true);
  }else{
    setShowEstremiDocStatus(false);
    setShowUltimoEnteDiServizio(false);
  }

  // Visualizza Nome e Cognome defunto
  if( 
    e.target.value === "C" ||
    e.target.value === "G" 
  ){
    setShowNomeCognomeDefuntoStatus(true);
  }else{
    setShowNomeCognomeDefuntoStatus(false);
  }

  // Visualizza Ultimo ente di servizio
  if( 
    e.target.value === "C" ||
    e.target.value === "G" ||
    e.target.value === "F"
  ){
    setShowUltimoEnteDiServizio(true);
  }else{
    setShowUltimoEnteDiServizio(false);
  }

 setSelectedStatusError((status === ""));
};


  dayjs.locale('it');
 
  // Data di nascita
  const [bDay, setbDay] = useState("");
  const [bDayError, setbDayError] = useState(false);
  const handleBDayChange = e => {
  
   setbDayError((bDay === ""));
   
   };

  const handleContinue = (currentStep) => {

    //console.log("handleContinue >>> " + currentStep);

    if(currentStep === 2){
      //console.log(name);
      //console.log(lastName); 
      //console.log(bDay);
      //console.log(bCity); 
      //console.log(bProv); 
      //console.log(bCountry);
      //console.log(email);
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  
      if (
        name.length < 1 ||
        lastName.length < 2 ||
        bDay === "" ||
        bCity === "" ||
        bProv === "" ||
        bCountry === "" ||
        email === "" ||
        !email.match(validRegex)) {
        //console.log(" return false;");
  
        setNameError((name.length < 1));
        setLastNameError((lastName.length < 2));
        setbDayError((bDay === ""));
        setEmailError(email === "" ||  !email.match(validRegex));
        setbCountryError((bCountry === ""));
        setbProvError((bProv === ""));
        setbCityError((bCity === ""));
      
        return false;
      } else {
        //console.log(" return true;");
        return true;
      }
    }

    if(currentStep === 3){
      //console.log(selectedStatus);
      //console.log(cmd);
      //console.log(grado);
      //console.log(enteDiServizio);
      //console.log(ultimoEnteDiServizio);
      //console.log(estremiDocStatus);
      //console.log(nomeCognomeDefuntoStatus);

      if(selectedStatus === ""){
        setSelectedStatusError();
        return false
      }

      if(selectedStatus === "A-M" ||
      selectedStatus === "A-C"){

          if (
            grado.length < 1 ||
            cmd.length < 2) {
            //console.log(" return false;");
      
            setGradoError((grado.length < 1));
            setCmdError((cmd.length < 2));
          
            return false;
          } else {
            //console.log(" return true;");
            return true;
          }
      }

      if(selectedStatus === "B-M" ||
      selectedStatus === "B-C"){
        if (
          grado.length < 1 ||
          cmd.length < 2 ||
          enteDiServizio < 1) {
          //console.log(" return false;");
    
          setGradoError((grado.length < 1));
          setCmdError((cmd.length < 2));
          setEnteDiServizioError((enteDiServizio.length < 2));
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "C"){
        if (
          ultimoEnteDiServizio.length < 1 ||
          nomeCognomeDefuntoStatus.length < 2 ||
          estremiDocStatus < 1) {
          //console.log(" return false;");
    
          setUltimoEnteDiServizioError((ultimoEnteDiServizio.length < 1));
          setNomeCognomeDefuntoStatusError((nomeCognomeDefuntoStatus.length < 2));
          setEstremiDocStatusError((estremiDocStatus.length < 2));
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "D-M" ||
      selectedStatus === "D-C"){
        if (
          grado.length < 1 ||
          cmd.length < 2 ||
          enteDiServizio < 1) {
          //console.log(" return false;");
    
          setGradoError((grado.length < 1));
          setCmdError((cmd.length < 2));
          setEnteDiServizioError((enteDiServizio.length < 2));
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "E"){
        if (
          grado.length < 1 ||
          estremiDocStatus.length < 2 ) {
          //console.log(" return false;");
    
          setGradoError((grado.length < 1));
          setEstremiDocStatusError((estremiDocStatus.length < 2));
         
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "F"){
        if (
          grado.length < 1 ||
          estremiDocStatus.length < 2 ||
          ultimoEnteDiServizio.length < 2) {
          //console.log(" return false;");
    
          setGradoError((grado.length < 1));
          setEstremiDocStatusError((estremiDocStatus.length < 2));
          setUltimoEnteDiServizioError((ultimoEnteDiServizio.length < 2))
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "G"){
        if (
          ultimoEnteDiServizio.length < 1 ||
          nomeCognomeDefuntoStatus.length < 2 ||
          estremiDocStatus < 1) {
          //console.log(" return false;");
    
          setUltimoEnteDiServizioError((ultimoEnteDiServizio.length < 1));
          setNomeCognomeDefuntoStatusError((nomeCognomeDefuntoStatus.length < 2));
          setEstremiDocStatusError((estremiDocStatus.length < 2));
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "H"){
        if (
          grado.length < 1 ||
          enteDiServizio.length < 2 ||
          estremiDocStatus < 1) {
          //console.log(" return false;");
    
          setGradoError((grado.length < 1));
          setEnteDiServizioError((enteDiServizio.length < 2));
          setEstremiDocStatusError((estremiDocStatus.length < 2));
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }

      if(selectedStatus === "I"){
        if (
          grado.length < 1 ||
          enteDiServizio.length < 2 ||
          estremiDocStatus < 1) {
          //console.log(" return false;");
    
          setGradoError((grado.length < 1));
          setEnteDiServizioError((enteDiServizio.length < 2));
          setEstremiDocStatusError((estremiDocStatus.length < 2));
        
          return false;
        } else {
          //console.log(" return true;");
          return true;
        }
      }
    }

    if(currentStep === 4){
      //turni
      //console.log(selectedGiugno);
      //console.log(selectedGiugnoP); 
      //console.log(selectedLuglio);
      //console.log(selectedLuglioP); 
      //console.log(selectedAgosto);
      //console.log(selectedAgostoP); 
      //console.log(selectedSettembre);
      //console.log(selectedSettembreP); 

      if(selectedGiugno === "" ||
      selectedLuglio === "" || 
      selectedAgosto === "" ||
      selectedSettembre === ""){
        
        setSelectedGiugnoError((selectedGiugno === ""));
        setSelectedLuglioError((selectedLuglio === ""));
        setSelectedAgostoError((selectedAgosto === ""));
        setSelectedSettembreError((selectedSettembre === ""));
      
        return false;
      }else{
        setSelectedGiugnoError((selectedGiugno === ""));
        setSelectedLuglioError((selectedLuglio === ""));
        setSelectedAgostoError((selectedAgosto === ""));
        setSelectedSettembreError((selectedSettembre === ""));
        return true;
      }

    }

    if(currentStep === 5){
      //altri abbonati
      //console.log(numberOfParents);
      //console.log(gradoParentelaEA1); 
      //console.log(nomeCognomeEA1);
      //console.log(etaEA1);
      //console.log(noteEA1);
      
      //console.log(etaEA1);
      if(numberOfParents === 1){
        if(gradoParentelaEA1 === "" || nomeCognomeEA1 === "" || etaEA1 === ""){

         
          setGradoParentelaEA1Error((gradoParentelaEA1 === ""));
          setNomeCognomeEA1Error((nomeCognomeEA1 === ""));
          setEtaEA1Error((etaEA1 === ""));

          return false;
        }else{
          return true;
        }
      }
    }
    return true;
   }

  const steps = [
    {
      label: 'Benvenuto!',
      content: <div>
        <Typography variant="subtitle1"  align='justify' paddingTop={2}>Gentile utente,</Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={0}>
        Nel solco della tradizione che da sempre caratterizza il Distaccamento Straordinario A.M. di “Miliscola”, anche per la stagione 2026 la struttura continuerà a rappresentare un punto di riferimento non solo per le attività istituzionali e addestrative dell’Accademia Aeronautica e della Forza Armata, ma anche per la promozione del benessere del personale militare e civile della Difesa e delle rispettive famiglie. 
        </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>
        Inserito nel comprensorio operativo dell’Accademia Aeronautica e funzionale alle attività di addestramento alla sopravvivenza in mare del personale frequentatore di Corso, il Distaccamento costituisce una realtà profondamente integrata nel territorio che lo ospita. In tale prospettiva, desidero confermare la ferma volontà dell’Aeronautica Militare di proseguire nel rapporto di collaborazione, rispetto reciproco e armoniosa convivenza con la comunità di Bacoli, valorizzando il legame con un contesto di straordinario pregio storico, naturalistico e umano. </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>
        Anche per il 2026, infatti, sarà garantita una quota dedicata di posti ombrellone riservata ai residenti del Comune di Bacoli, quale concreta testimonianza della volontà di mantenere il Distaccamento aperto al territorio e sempre più inserito nel tessuto sociale locale. 
        </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>
        Particolare attenzione continuerà inoltre ad essere rivolta all’inclusione e all’accessibilità. La struttura conferma il proprio impegno nell’accoglienza delle persone con disabilità e dei nuclei familiari che necessitano di specifiche attenzioni, nella convinzione che il valore di una comunità si misuri anche dalla capacità di garantire dignità, partecipazione e serenità a chi vive condizioni di maggiore fragilità. In tale quadro, il regolamento 2026 prevede anche la possibilità, per gli utenti non vedenti, di accedere alla struttura accompagnati dai propri cani guida, così da favorire una fruizione sempre più completa e realmente inclusiva degli spazi e dei servizi disponibili.
        </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>
        L’attenzione alla persona si accompagna naturalmente alla cura degli ambienti comuni e al rispetto del bene collettivo. Sono certo che tutti gli utenti del Distaccamento contribuiranno, con senso civico, equilibrio e responsabilità, a preservare il decoro, la pulizia, la serenità e la vivibilità della struttura, nel rispetto reciproco e dell’ambiente che ci circonda.
        </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>
        L’impegno dell’Aeronautica Militare nel sociale troverà inoltre ulteriore espressione attraverso il progetto solidale “Un Dono dal Cielo 2026”, iniziativa che testimonia concretamente la vicinanza della Forza Armata alle realtà sanitarie e assistenziali impegnate quotidianamente a favore dei più fragili, grazie anche al contributo volontario del personale, di associazioni e di privati cittadini. 
        </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>
        Il personale del Distaccamento Straordinario A.M. di “Miliscola” sarà, come sempre, a disposizione degli utenti e dei loro ospiti con professionalità, spirito di servizio e massima disponibilità, con l’obiettivo di garantire un ambiente accogliente, ordinato e all’altezza dei valori che l’Aeronautica Militare rappresenta. 
        </Typography>
        <Typography variant="subtitle1" align='justify' paddingTop={2}>Nel ringraziare tutti per la collaborazione, auguro una serena permanenza presso il Distaccamento Straordinario A.M. di “Miliscola”. </Typography>
        
        <Typography variant="subtitle1" align='right' paddingTop={4} paddingBottom={5}>
        IL COMANDANTE Gen. D.A. Davide CIPELLETTI
        </Typography>
        </div>,
    },
    {
      label: 'Informazioni',
      content: <div>
      <Typography variant="subtitle1"  align='justify' paddingTop={2}>Il periodo di apertura agli utenti dello stabilimento balneare <strong>attivo</strong> presso il Distaccamento Straordinario A.M. di “Miliscola”, salvo diverso avviso, è dal <strong>13 giugno</strong> al <strong>30 settembre 2026</strong></Typography>
      <Typography variant="subtitle1" align='justify' paddingTop={2}>
      Fino al <strong>14 giugno</strong> compreso ed a partire dal <strong>16 settembre</strong> fino a chiusura della stagione balneare, la formula di accesso sarà <strong>esclusivamente</strong> quella di “utente giornaliero”.
      </Typography>
      <Typography variant="subtitle1" align='justify' paddingTop={2}>
      Anche quest'anno, per il personale appartenente alle categorie A - B - C - D - E - F - G - H - I (consulta il regolamento per maggiori informazioni) è possibile presentare richiesta di abbonamento.
      </Typography>
     <Typography variant="subtitle1" align='justify' paddingTop={2}>
      Il presente modulo (attivo dal 11 Giugno al 21 Giugno 2026) ti guiderà nella compilazione della richiesta di abbonamento, inoltrandola in via telematica all' ufficio di competenza.
      </Typography> 
      {/*    <Typography variant="subtitle1" align='justify' paddingTop={2}>
      <strong>Non</strong> è più possibile presentare richiesta di abbonamento, il termine ultimo era il <strong> 15 Giugno 2026</strong>.
      </Typography>
      <Typography variant="subtitle1" align='justify' paddingTop={2} paddingBottom={5}>
      Le richieste ricevute sono al momento <strong>in valutazione</strong>. l'utente riceverà l'esito della valutazione con le successive azioni da intraprendere nei prossimi giorni.
      </Typography>*/}
      </div>
    },
    {
      label: 'Dati personali',
      content: <div>
         <Grid
            container
            sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
            rowGap={3}
          >
            <Grid item xs={12} sx={{ width: "100%"}}>
              <TextField
                      required
                      value={name}
                      onChange={handleNameChange}
                      onBlur={handleNameChange}
                      error={nameError}
                      helperText={nameError ? "" : ""}
                      id="outlined-name-currency"
                      label="Nome"
                      placeholder=""
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                ></TextField>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%"}}>
              <TextField
                      required
                      value={lastName}
                      onChange={handleLastNameChange}
                      onBlur={handleLastNameChange}
                      error={lastNameError}
                      helperText={lastNameError ? "" : ""}
                      id="outlined-lastName-currency"
                      label="Cognome"
                      placeholder=""
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                ></TextField>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%"}}>
              <TextField
                      required
                      value={bCity}
                      onChange={handlebCityChange}
                      onBlur={handlebCityChange}
                      error={bCityError}
                      helperText={bCityError ? "" : ""}
                      id="outlined-bCity-currency"
                      label="Citta di nascita"
                      placeholder=""
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                ></TextField>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%"}}>
              <TextField
                      required
                      value={bProv}
                      onChange={handlebProvChange}
                      onBlur={handlebProvChange}
                      error={bProvError}
                      helperText={bProvError ? "" : ""}
                      id="outlined-bProv-currency"
                      label="Provincia di nascita"
                      placeholder=""
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                ></TextField>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%"}}>
              <TextField
                      required
                      value={bCountry}
                      onChange={handlebCountryChange}
                      onBlur={handlebCountryChange}
                      error={bCountryError}
                      helperText={bCountryError ? "" : ""}
                      id="outlined-bCountry-currency"
                      label="Nazione di nascita"
                      placeholder=""
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                ></TextField>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Data di nascita"
                  sx={{ boxShadow: 5, borderRadius: 1, width: "100%" }}
                  onChange={(newValue) =>
                    setbDay(dayjs(newValue).format("MM/DD/YYYY"))
                  }
                  error={bDayError}
                  onBlur={handleBDayChange}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%"}}>
                    <TextField
                      required
                      value={email}
                      onChange={handleEmailChange}
                      onBlur={handleEmailChange}
                      error={emailError}
                      helperText={emailError ? "" : ""}
                      id="outlined-email-currency"
                      label="Email"
                      placeholder=""
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    ></TextField>
                  </Grid>
          </Grid>
      </div>,
    },
    {
      label: 'Categoria di appartenenza',
      content: <div>
         <Grid
            container
            sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
            rowGap={3}
          >
            <Grid item xs={12} sx={{ width: "100%" }}>
                    <TextField
                      select
                      label="Categoria di appartenenza"
                      onChange={handleSelectedStatusChange}
                      onBlur={handleSelectedStatusChange}
                      id="outlined-selectedStatus-currency"
                      error={selectedStatusError}
                      value={selectedStatus}
                      defaultValue=""
                      placeholder="Seleziona"
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                      {status.map((option) => (
                        <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  { (showGrado === true) ? (
                  <Grid item xs={12} sx={{ width: "100%"}}>
                    <TextField
                            required
                            id="outlined-grado-currency"
                            label="Grado o Area Funzionale"
                            placeholder=""
                            onChange={handleGradoChange}
                            onBlur={handleGradoChange}
                            error={gradoError}
                            value={grado}
                            xs={12}
                            sx={{
                              width: "100%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                            }}
                      ></TextField>
                  </Grid> ) : (<></>) }

                  { (showCMD === true) ? (
                   <Grid item xs={12} sx={{ width: "100%"}}>
                   <TextField
                           required
                           id="outlined-cmd-currency"
                           label="Numero CMD"
                           onChange={handleCmdChange}
                           onBlur={handleCmdChange}
                           error={cmdError}
                           value={cmd}
                           placeholder=""
                           xs={12}
                           sx={{
                             width: "100%",
                             textAlign: "left",
                             boxShadow: 5,
                             borderRadius: 1,
                           }}
                     ></TextField>
                 </Grid> ) : (<></>) }

                 { (showEnteDiServizio === true) ? (
                   <Grid item xs={12} sx={{ width: "100%"}}>
                   <TextField
                           required
                           id="outlined-entediservizio-currency"
                           onChange={handleEnteDiServizioChange}
                           onBlur={handleEnteDiServizioChange}
                           error={enteDiServizioError}
                           value={enteDiServizio}
                           label="Ente/Comando/Amministrazione di servizio"
                           placeholder=""
                           xs={12}
                           sx={{
                             width: "100%",
                             textAlign: "left",
                             boxShadow: 5,
                             borderRadius: 1,
                           }}
                     ></TextField>
                 </Grid>) : (<></>) }

                 { (showUltimoEnteDiServizio === true) ? (
                     <Grid item xs={12} sx={{ width: "100%"}}>
                     <TextField
                             required
                             id="outlined-ultimoente-currency"
                             label="Ultimo Ente di servizio"
                             onChange={handleUltimoEnteDiServizioChange}
                             onBlur={handleUltimoEnteDiServizioChange}
                             error={ultimoEnteDiServizioError}
                             value={ultimoEnteDiServizio}
                             placeholder=""
                             xs={12}
                             sx={{
                               width: "100%",
                               textAlign: "left",
                               boxShadow: 5,
                               borderRadius: 1,
                             }}
                       ></TextField>
                   </Grid>) : (<></>) }

                   { (showNomeCognomeDefuntoStatus === true) ? (
                      <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              required
                              id="outlined-nomecognome-currency"
                              label="Nome e Cognome del coniuge defunto"
                              onChange={handlenomeCognomeDefuntoStatusChange}
                              onBlur={handlenomeCognomeDefuntoStatusChange}
                              error={nomeCognomeDefuntoStatusError}
                              value={nomeCognomeDefuntoStatus}
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>) : (<></>) }

                   { (showEstremiDocStatus === true) ? (
                      <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              required
                              id="outlined-documento-currency"
                              label="Estremi documento che attesti l'appartenenza alla categoria scelta"
                              onChange={handleEstremiDocStatusChange}
                              onBlur={handleEstremiDocStatusChange}
                              error={estremiDocStatusError}
                              value={estremiDocStatus}
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>) : (<></>) }

                
              
               
               
          </Grid>
      </div>,
    },
    {
      label: 'Scelta turni',
      content: <div>
         <Grid
            container
            sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
            rowGap={3}
          >
             <Typography variant="subtitle1" align='justify' paddingTop={2}>
               Indica per ogni periodo se sei interessato a presentare domanda oppure no. Per i periodi scelti indica la priorita.
              </Typography>
            <Grid item xs={12} sx={{ width: "100%" }}>
                    <TextField
                      id="outlined-turnogiugno-currency"
                      select
                      label="Turno dal 15 Giugno al 30 Giugno"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleGiugnoSelectedChange}
                      onBlur={handleGiugnoSelectedChange}
                      error={selectedGiugnoError}
                      value={selectedGiugno}
                      xs={6}
                      sx={{
                        width: "63%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                        marginRight: "1%"
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          SI
                        </MenuItem>
                        <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                          NO
                        </MenuItem>
                    </TextField>
                    { (selectedGiugno == 1) ? (
                      <TextField
                      id="outlined-giugnopriorita-currency"
                      select
                      label="Priorita'"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleGiugnoPSelectedChange}
                      onBlur={handleGiugnoPSelectedChange}
                      error={selectedGiugnoPError}
                      value={selectedGiugnoP}
                      xs={6}
                      sx={{
                        width: "35%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          1
                        </MenuItem>
                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                          2
                        </MenuItem>
                        <MenuItem key={3} value={3} style={{whiteSpace: 'normal'}}>
                          ALTRO
                        </MenuItem>
                    </TextField>
                    ) : (<></>)}
                    
                  </Grid>
                  <Grid item xs={12} sx={{ width: "100%" }}>
                    <TextField
                      id="outlined-luglio-currency"
                      select
                      label="Turno dal 1 Luglio al 31 Luglio"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleLuglioSelectedChange}
                      onBlur={handleLuglioSelectedChange}
                      error={selectedLuglioError}
                      value={selectedLuglio}
                      xs={6}
                      sx={{
                        width: "63%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                        marginRight: "1%"
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          SI
                        </MenuItem>
                        <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                          NO
                        </MenuItem>
                    </TextField>
                    { (selectedLuglio == 1) ? (
                    <TextField
                      id="outlined-lugliopriorita-currency"
                      select
                      label="Priorita'"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleLuglioPSelectedChange}
                      onBlur={handleLuglioPSelectedChange}
                      error={selectedLuglioPError}
                      value={selectedLuglioP}
                      xs={6}
                      sx={{
                        width: "35%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          1
                        </MenuItem>
                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                          2
                        </MenuItem>
                        <MenuItem key={3} value={3} style={{whiteSpace: 'normal'}}>
                          ALTRO
                        </MenuItem>
                    </TextField>):(<></>)}
                  </Grid>
                  <Grid item xs={12} sx={{ width: "100%" }}>
                    <TextField
                      id="outlined-agosto-currency"
                      select
                      label="Turno dal 1 Agosto al 31 Agosto"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleAgostoSelectedChange}
                      onBlur={handleAgostoSelectedChange}
                      error={selectedAgostoError}
                      value={selectedAgosto}
                      xs={6}
                      sx={{
                        width: "63%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                        marginRight: "1%"
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          SI
                        </MenuItem>
                        <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                          NO
                        </MenuItem>
                    </TextField>
                    { (selectedAgosto == 1) ? (
                    <TextField
                      id="outlined-agostopriorita-currency"
                      select
                      label="Priorita'"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleAgostoPSelectedChange}
                      onBlur={handleAgostoPSelectedChange}
                      error={selectedAgostoPError}
                      value={selectedAgostoP}
                      xs={6}
                      sx={{
                        width: "35%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          1
                        </MenuItem>
                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                          2
                        </MenuItem>
                        <MenuItem key={3} value={3} style={{whiteSpace: 'normal'}}>
                          ALTRO
                        </MenuItem>
                    </TextField>):(<></>)}
                  </Grid>
                  <Grid item xs={12} sx={{ width: "100%" }}>
                    <TextField
                      id="outlined-settembre-currency"
                      select
                      label="Turno dal 1 Settembre al 15 Settembre"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleSettembreSelectedChange}
                      onBlur={handleSettembreSelectedChange}
                      error={selectedSettembreError}
                      value={selectedSettembre}
                      xs={6}
                      sx={{
                        width: "63%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                        marginRight: "1%"
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          SI
                        </MenuItem>
                        <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                          NO
                        </MenuItem>
                    </TextField>
                    { (selectedSettembre == 1) ? (
                    <TextField
                      id="outlined-settembrepriorita-currency"
                      select
                      label="Priorita'"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleSettembrePSelectedChange}
                      onBlur={handleSettembrePSelectedChange}
                      error={selectedSettembrePError}
                      value={selectedSettembreP}
                      xs={6}
                      sx={{
                        width: "35%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          1
                        </MenuItem>
                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                          2
                        </MenuItem>
                        <MenuItem key={3} value={3} style={{whiteSpace: 'normal'}}>
                          ALTRO
                        </MenuItem>
                    </TextField>) : (<></>)}
                  </Grid>
                  
          </Grid>
      </div>,
    },
    {
      label: 'Familiari e/o Conviventi',
      content: <div>
         <Grid
            container
            sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
            rowGap={3}
          >
             <TextField
                      id="outlined-figliminorenni-currency"
                      select
                      label="Ho figli con età inferiore o uguale ai 12 anni"
                      onChange={handlesetFigliMinorenniChange}
                      onBlur={handlesetFigliMinorenniChange}
                      error={figliMinorenniError}
                      value={figliMinorenni}
                      defaultValue=""
                      placeholder="Seleziona"
                      xs={6}
                      sx={{
                        width: "63%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                        marginRight: "1%"
                      }}
                    >
                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                          SI
                        </MenuItem>
                        <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                          NO
                        </MenuItem>
                    </TextField>
             <Typography variant="subtitle1" align='justify' paddingTop={2}>
              Di seguito puoi aggiungere le richieste di abbonamento per altri familiari e/o conviventi.
              Indicare anche i familiari e/o conviventi con età inferiore o uguale ai 12 anni.
              Per ognuno di essi puoi specificare un periodo utilizzando il campo note turni. 
              Ricorda che l'ammissibilita' delle tue richieste e regolamentata dalle direttive dell' Accademia Aeronautica che puoi consultare nel Regolamento 2026.
              </Typography>
              <Grid item xs={12} sx={{ width: "100%" }}>
              <TextField
                      id="outlined-numberofparents-currency"
                      select
                      label="Numero richieste abbonamenti oltre il titolare"
                      defaultValue=""
                      placeholder="Seleziona"
                      onChange={handleNumberOfParentsChange}
                      onBlur={handleNumberOfParentsChange}
                      error={numberOfParentsError}
                      value={numberOfParents}
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                      {numbersOfRequests.map((option) => (
                        <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>

              </Grid>
             
              { (numberOfParents >= 1) ? (
                <Grid item xs={12} sx={{ width: "100%" }}>
                      <TextField
                        id="outlined-gradodiparentelaEA1-currency"
                        select
                        label="Grado di parentela"
                        onChange={handleGradoParentelaEA1Change}
                        onBlur={handleGradoParentelaEA1Change}
                        error={gradoParentelaEA1Error}
                        value={gradoParentelaEA1}
                        defaultValue=""
                        placeholder="Seleziona"
                        xs={4}
                        sx={{
                          width: "20%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                      >
                          {gradoParentela.map((option) => (
                          <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        required
                        id="outlined-nomecognomeEA1-currency"
                        onChange={handleNomeCognomeEA1Change}
                        onBlur={handleNomeCognomeEA1Change}
                        error={nomeCognomeEA1Error}
                        value={nomeCognomeEA1}
                        label="Nome e Cognome"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "45%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                  ></TextField>
                    <TextField
                        id="outlined-etaEA1-currency"
                        select
                        label="Eta'"
                        defaultValue=""
                        placeholder="Seleziona"
                        onChange={handleEtaEA1Change}
                        onBlur={handleEtaEA1Change}
                        error={etaEA1Error}
                        value={etaEA1}
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                      >
                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                            Fino a 12 anni compiuti
                          </MenuItem>
                          <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                            Maggiore di 12 anni
                          </MenuItem>
                      </TextField>
                      <TextField
                        required
                        id="outlined-noteEA1-currency"
                        onChange={handleNoteEA1Change}
                        onBlur={handleNoteEA1Change}
                        value={noteEA1}
                        label="Note turni"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                        }}
                  ></TextField>
                </Grid>
              ) : (<></>)}
              { (numberOfParents >= 2) ? (
               <Grid item xs={12} sx={{ width: "100%" }}>
               <TextField
                 id="outlined-gradodiparentelaEA2-currency"
                 select
                 label="Grado di parentela"
                 onChange={handleGradoParentelaEA2Change}
                 onBlur={handleGradoParentelaEA2Change}
                 error={gradoParentelaEA2Error}
                 value={gradoParentelaEA2}
                 defaultValue=""
                 placeholder="Seleziona"
                 xs={4}
                 sx={{
                   width: "20%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
                   {gradoParentela.map((option) => (
                   <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                     {option.label}
                   </MenuItem>
                 ))}
               </TextField>
               <TextField
                 required
                 id="outlined-nomecognomeEA2-currency"
                 onChange={handleNomeCognomeEA2Change}
                 onBlur={handleNomeCognomeEA2Change}
                 error={nomeCognomeEA2Error}
                 value={nomeCognomeEA2}
                 label="Nome e Cognome"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "45%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
           ></TextField>
             <TextField
                 id="outlined-etaEA2-currency"
                 select
                 label="Eta'"
                 defaultValue=""
                 placeholder="Seleziona"
                 onChange={handleEtaEA2Change}
                 onBlur={handleEtaEA2Change}
                 error={etaEA2Error}
                 value={etaEA2}
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
                   <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                     Fino a 12 anni compiuti
                   </MenuItem>
                   <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                     Maggiore di 12 anni
                   </MenuItem>
               </TextField>
               <TextField
                 required
                 id="outlined-noteEA2-currency"
                 onChange={handleNoteEA2Change}
                 onBlur={handleNoteEA2Change}
                 value={noteEA2}
                 label="Note turni"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                 }}
           ></TextField>
                </Grid>
              ) : (<></>)}
              { (numberOfParents >= 3) ? (
                <Grid item xs={12} sx={{ width: "100%" }}>
                <TextField
                  id="outlined-gradodiparentelaEA3-currency"
                  select
                  label="Grado di parentela"
                  onChange={handleGradoParentelaEA3Change}
                  onBlur={handleGradoParentelaEA3Change}
                  error={gradoParentelaEA3Error}
                  value={gradoParentelaEA3}
                  defaultValue=""
                  placeholder="Seleziona"
                  xs={4}
                  sx={{
                    width: "20%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                    {gradoParentela.map((option) => (
                    <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  required
                  id="outlined-nomecognomeEA3-currency"
                  onChange={handleNomeCognomeEA3Change}
                  onBlur={handleNomeCognomeEA3Change}
                  error={nomeCognomeEA3Error}
                  value={nomeCognomeEA3}
                  label="Nome e Cognome"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "45%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
            ></TextField>
              <TextField
                  id="outlined-etaEA3-currency"
                  select
                  label="Eta'"
                  defaultValue=""
                  placeholder="Seleziona"
                  onChange={handleEtaEA3Change}
                  onBlur={handleEtaEA3Change}
                  error={etaEA3Error}
                  value={etaEA3}
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                    <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                      Fino a 12 anni compiuti
                    </MenuItem>
                    <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                      Maggiore di 12 anni
                    </MenuItem>
                </TextField>
                <TextField
                  required
                  id="outlined-noteEA3-currency"
                  onChange={handleNoteEA3Change}
                  onBlur={handleNoteEA3Change}
                  value={noteEA3}
                  label="Note turni"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                  }}
            ></TextField>
                 </Grid>
              ) : (<></>)}
               { (numberOfParents >= 4) ? (
                <Grid item xs={12} sx={{ width: "100%" }}>
               <TextField
                 id="outlined-gradodiparentelaEA4-currency"
                 select
                 label="Grado di parentela"
                 onChange={handleGradoParentelaEA4Change}
                 onBlur={handleGradoParentelaEA4Change}
                 error={gradoParentelaEA4Error}
                 value={gradoParentelaEA4}
                 defaultValue=""
                 placeholder="Seleziona"
                 xs={4}
                 sx={{
                   width: "20%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
                   {gradoParentela.map((option) => (
                   <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                     {option.label}
                   </MenuItem>
                 ))}
               </TextField>
               <TextField
                 required
                 id="outlined-nomecognomeEA4-currency"
                 onChange={handleNomeCognomeEA4Change}
                 onBlur={handleNomeCognomeEA4Change}
                 error={nomeCognomeEA4Error}
                 value={nomeCognomeEA4}
                 label="Nome e Cognome"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "45%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
           ></TextField>
             <TextField
                 id="outlined-etaEA4-currency"
                 select
                 label="Eta'"
                 defaultValue=""
                 placeholder="Seleziona"
                 onChange={handleEtaEA4Change}
                 onBlur={handleEtaEA4Change}
                 error={etaEA4Error}
                 value={etaEA4}
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
                   <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                     Fino a 12 anni compiuti
                   </MenuItem>
                   <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                     Maggiore di 12 anni
                   </MenuItem>
               </TextField>
               <TextField
                 required
                 id="outlined-noteEA4-currency"
                 onChange={handleNoteEA4Change}
                 onBlur={handleNoteEA4Change}
                 value={noteEA4}
                 label="Note turni"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                 }}
           ></TextField>
                </Grid>
              ) : (<></>)}
               { (numberOfParents >= 5) ? (
                  <Grid item xs={12} sx={{ width: "100%" }}>
                <TextField
                  id="outlined-gradodiparentelaEA5-currency"
                  select
                  label="Grado di parentela"
                  onChange={handleGradoParentelaEA5Change}
                  onBlur={handleGradoParentelaEA5Change}
                  error={gradoParentelaEA5Error}
                  value={gradoParentelaEA5}
                  defaultValue=""
                  placeholder="Seleziona"
                  xs={4}
                  sx={{
                    width: "20%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                    {gradoParentela.map((option) => (
                    <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  required
                  id="outlined-nomecognomeEA5-currency"
                  onChange={handleNomeCognomeEA5Change}
                  onBlur={handleNomeCognomeEA5Change}
                  error={nomeCognomeEA5Error}
                  value={nomeCognomeEA5}
                  label="Nome e Cognome"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "45%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
            ></TextField>
              <TextField
                  id="outlined-etaEA5-currency"
                  select
                  label="Eta'"
                  defaultValue=""
                  placeholder="Seleziona"
                  onChange={handleEtaEA5Change}
                  onBlur={handleEtaEA5Change}
                  error={etaEA5Error}
                  value={etaEA5}
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                    <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                      Fino a 12 anni compiuti
                    </MenuItem>
                    <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                      Maggiore di 12 anni
                    </MenuItem>
                </TextField>
                <TextField
                  required
                  id="outlined-noteEA5-currency"
                  onChange={handleNoteEA5Change}
                  onBlur={handleNoteEA5Change}
                  value={noteEA5}
                  label="Note turni"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                  }}
            ></TextField>
                  </Grid>
              ) : (<></>)}
              { (numberOfParents >= 6) ? (
                  <Grid item xs={12} sx={{ width: "100%" }}>
                  <TextField
                    id="outlined-gradodiparentelaEA6-currency"
                    select
                    label="Grado di parentela"
                    onChange={handleGradoParentelaEA6Change}
                    onBlur={handleGradoParentelaEA6Change}
                    error={gradoParentelaEA6Error}
                    value={gradoParentelaEA6}
                    defaultValue=""
                    placeholder="Seleziona"
                    xs={4}
                    sx={{
                      width: "20%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                      {gradoParentela.map((option) => (
                      <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    required
                    id="outlined-nomecognomeEA6-currency"
                    onChange={handleNomeCognomeEA6Change}
                    onBlur={handleNomeCognomeEA6Change}
                    error={nomeCognomeEA6Error}
                    value={nomeCognomeEA6}
                    label="Nome e Cognome"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "45%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
              ></TextField>
                <TextField
                    id="outlined-etaEA6-currency"
                    select
                    label="Eta'"
                    defaultValue=""
                    placeholder="Seleziona"
                    onChange={handleEtaEA6Change}
                    onBlur={handleEtaEA6Change}
                    error={etaEA6Error}
                    value={etaEA6}
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                      <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                        Fino a 12 anni compiuti
                      </MenuItem>
                      <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                        Maggiore di 12 anni
                      </MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="outlined-noteEA6-currency"
                    onChange={handleNoteEA6Change}
                    onBlur={handleNoteEA6Change}
                    value={noteEA6}
                    label="Note turni"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                    }}
              ></TextField>
                  </Grid>
              ) : (<></>)}
               { (numberOfParents >= 7) ? (
                    <Grid item xs={12} sx={{ width: "100%" }}>
                  <TextField
                    id="outlined-gradodiparentelaEA7-currency"
                    select
                    label="Grado di parentela"
                    onChange={handleGradoParentelaEA7Change}
                    onBlur={handleGradoParentelaEA7Change}
                    error={gradoParentelaEA7Error}
                    value={gradoParentelaEA7}
                    defaultValue=""
                    placeholder="Seleziona"
                    xs={4}
                    sx={{
                      width: "20%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                      {gradoParentela.map((option) => (
                      <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    required
                    id="outlined-nomecognomeEA7-currency"
                    onChange={handleNomeCognomeEA7Change}
                    onBlur={handleNomeCognomeEA7Change}
                    error={nomeCognomeEA7Error}
                    value={nomeCognomeEA7}
                    label="Nome e Cognome"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "45%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
              ></TextField>
                <TextField
                    id="outlined-etaEA7-currency"
                    select
                    label="Eta'"
                    defaultValue=""
                    placeholder="Seleziona"
                    onChange={handleEtaEA7Change}
                    onBlur={handleEtaEA7Change}
                    error={etaEA7Error}
                    value={etaEA7}
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                      <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                        Fino a 12 anni compiuti
                      </MenuItem>
                      <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                        Maggiore di 12 anni
                      </MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="outlined-noteEA7-currency"
                    onChange={handleNoteEA7Change}
                    onBlur={handleNoteEA7Change}
                    value={noteEA7}
                    label="Note turni"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                    }}
              ></TextField>
                    </Grid>
              ) : (<></>)}
               { (numberOfParents >= 8) ? (
                  <Grid item xs={12} sx={{ width: "100%" }}>
                <TextField
                  id="outlined-gradodiparentelaEA8-currency"
                  select
                  label="Grado di parentela"
                  onChange={handleGradoParentelaEA8Change}
                  onBlur={handleGradoParentelaEA8Change}
                  error={gradoParentelaEA8Error}
                  value={gradoParentelaEA8}
                  defaultValue=""
                  placeholder="Seleziona"
                  xs={4}
                  sx={{
                    width: "20%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                    {gradoParentela.map((option) => (
                    <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  required
                  id="outlined-nomecognomeEA8-currency"
                  onChange={handleNomeCognomeEA8Change}
                  onBlur={handleNomeCognomeEA8Change}
                  error={nomeCognomeEA8Error}
                  value={nomeCognomeEA8}
                  label="Nome e Cognome"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "45%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
            ></TextField>
              <TextField
                  id="outlined-etaEA8-currency"
                  select
                  label="Eta'"
                  defaultValue=""
                  placeholder="Seleziona"
                  onChange={handleEtaEA8Change}
                  onBlur={handleEtaEA8Change}
                  error={etaEA8Error}
                  value={etaEA8}
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                    <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                      Fino a 12 anni compiuti
                    </MenuItem>
                    <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                      Maggiore di 12 anni
                    </MenuItem>
                </TextField>
                <TextField
                  required
                  id="outlined-noteEA8-currency"
                  onChange={handleNoteEA8Change}
                  onBlur={handleNoteEA8Change}
                  value={noteEA8}
                  label="Note turni"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                  }}
            ></TextField>
                  </Grid>
              ) : (<></>)}
               { (numberOfParents >= 9) ? (
                 <Grid item xs={12} sx={{ width: "100%" }}>
                 <TextField
                   id="outlined-gradodiparentelaEA9-currency"
                   select
                   label="Grado di parentela"
                   onChange={handleGradoParentelaEA9Change}
                   onBlur={handleGradoParentelaEA9Change}
                   error={gradoParentelaEA9Error}
                   value={gradoParentelaEA9}
                   defaultValue=""
                   placeholder="Seleziona"
                   xs={4}
                   sx={{
                     width: "20%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                     {gradoParentela.map((option) => (
                     <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                       {option.label}
                     </MenuItem>
                   ))}
                 </TextField>
                 <TextField
                   required
                   id="outlined-nomecognomeEA9-currency"
                   onChange={handleNomeCognomeEA9Change}
                   onBlur={handleNomeCognomeEA9Change}
                   error={nomeCognomeEA9Error}
                   value={nomeCognomeEA9}
                   label="Nome e Cognome"
                   placeholder=""
                   xs={4}
                   sx={{
                     width: "45%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
             ></TextField>
               <TextField
                   id="outlined-etaEA9-currency"
                   select
                   label="Eta'"
                   defaultValue=""
                   placeholder="Seleziona"
                   onChange={handleEtaEA9Change}
                   onBlur={handleEtaEA9Change}
                   error={etaEA9Error}
                   value={etaEA9}
                   xs={4}
                   sx={{
                     width: "15%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                     <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                       Fino a 12 anni compiuti
                     </MenuItem>
                     <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                       Maggiore di 12 anni
                     </MenuItem>
                 </TextField>
                 <TextField
                        required
                        id="outlined-noteEA9-currency"
                        onChange={handleNoteEA9Change}
                        onBlur={handleNoteEA9Change}
                        value={noteEA9}
                        label="Note turni"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                        }}
                  ></TextField>
                   </Grid>
              ) : (<></>)}
               { (numberOfParents >= 10) ? (
                 <Grid item xs={12} sx={{ width: "100%" }}>
                 <TextField
                   id="outlined-gradodiparentelaEA10-currency"
                   select
                   label="Grado di parentela"
                   onChange={handleGradoParentelaEA10Change}
                   onBlur={handleGradoParentelaEA10Change}
                   error={gradoParentelaEA10Error}
                   value={gradoParentelaEA10}
                   defaultValue=""
                   placeholder="Seleziona"
                   xs={4}
                   sx={{
                     width: "20%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                     {gradoParentela.map((option) => (
                     <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                       {option.label}
                     </MenuItem>
                   ))}
                 </TextField>
                 <TextField
                   required
                   id="outlined-nomecognomeEA10-currency"
                   onChange={handleNomeCognomeEA10Change}
                   onBlur={handleNomeCognomeEA10Change}
                   error={nomeCognomeEA10Error}
                   value={nomeCognomeEA10}
                   label="Nome e Cognome"
                   placeholder=""
                   xs={4}
                   sx={{
                     width: "45%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
             ></TextField>
               <TextField
                   id="outlined-etaEA10-currency"
                   select
                   label="Eta'"
                   defaultValue=""
                   placeholder="Seleziona"
                   onChange={handleEtaEA10Change}
                   onBlur={handleEtaEA10Change}
                   error={etaEA10Error}
                   value={etaEA10}
                   xs={4}
                   sx={{
                     width: "15%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                     <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                       Fino a 12 anni compiuti
                     </MenuItem>
                     <MenuItem key={0} value={0} style={{whiteSpace: 'normal'}}>
                       Maggiore di 12 anni
                     </MenuItem>
                 </TextField>
                 <TextField
                        required
                        id="outlined-noteEA10-currency"
                        onChange={handleNoteEA10Change}
                        onBlur={handleNoteEA10Change}
                        value={noteEA10}
                        label="Note turni"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                        }}
                  ></TextField>
                   </Grid>
              ) : (<></>)}
          </Grid>
      </div>,
    },
    {
      label: 'Riepilogo ed Invio',
      content: <div>
      <Typography variant="subtitle1"  align='justify' paddingTop={2}>Di seguito vengono riportate le informazioni inserite</Typography>

      <Typography variant="subtitle1"  align='left' paddingTop={2}><strong>DATI PERSONALI</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome: <strong>{name.toUpperCase()}</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Cognome: <strong>{lastName.toUpperCase()}</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Data di nascita: <strong>{bDay}</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Nazione di nascita: <strong>{bCountry.toUpperCase()}</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Provincia di nascita: <strong>{bProv.toUpperCase()}</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Città di nascita: <strong>{bCity.toUpperCase()}</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Email: <strong>{email.toLowerCase()}</strong></Typography>

      <Typography variant="subtitle1"  align='left' paddingTop={2}><strong>CATEGORIA DI APPARTENENZA</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Categoria: <strong>{selectedStatus}</strong></Typography>
       {
         ( selectedStatus === "A-M" ||
         selectedStatus === "A-C" ||
         selectedStatus === "B-M" ||
         selectedStatus === "B-C" ||
         selectedStatus === "D-M" ||
         selectedStatus === "D-C" ||
         selectedStatus === "H" ||
         selectedStatus === "I" ||
         selectedStatus === "E" ||
         selectedStatus === "F") ? ( <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado o area funzionale: <strong>{grado.toUpperCase()}</strong></Typography> ) : (<></>)
       }
        {
         ( selectedStatus === "A-M" ||
         selectedStatus === "A-C" ||
         selectedStatus === "B-M" ||
         selectedStatus === "B-C" ||
         selectedStatus === "D-M" ||
         selectedStatus === "D-C" ) ? (  <Typography variant="subtitle1"  align='left' paddingTop={0}>Numero CMD: <strong>{cmd.toUpperCase()}</strong></Typography>  ) : (<></>)
       }
    
       {
         ( selectedStatus === "B-M" ||
         selectedStatus === "B-C" ||
         selectedStatus === "D-M" ||
         selectedStatus === "D-C" ||
         selectedStatus === "H" ||
         selectedStatus === "I") ? (   <Typography variant="subtitle1"  align='left' paddingTop={0}>Ente/Comando/Amministrazione di servizio: <strong>{enteDiServizio.toUpperCase()}</strong></Typography>  ) : (<></>)
       }

      {
         ( selectedStatus === "C" ||
         selectedStatus === "G" ||
         selectedStatus === "F") ? (  <Typography variant="subtitle1"  align='left' paddingTop={0}>Ultimo ente di servizio: <strong>{ultimoEnteDiServizio.toUpperCase()}</strong></Typography>  ) : (<></>)
       }

      {
         ( 
         selectedStatus === "C" ||
         selectedStatus === "G") ? (  <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome del coniuge defunto: <strong>{nomeCognomeDefuntoStatus.toUpperCase()}</strong></Typography>  ) : (<></>)
       }
     
     {
         ( selectedStatus === "C" ||
         selectedStatus === "G" ||
         selectedStatus === "H" ||
         selectedStatus === "I" ||
         selectedStatus === "E" ||
         selectedStatus === "F") ? (   <Typography variant="subtitle1"  align='left' paddingTop={0}>Estremi documento che attesti l'appartenenza alla categoria scelta: <strong>{estremiDocStatus.toUpperCase()}</strong></Typography>  ) : (<></>)
       }
     
     
      <Typography variant="subtitle1"  align='left' paddingTop={2}><strong>SCELTA TURNI</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Turno dal 15 Giugno al 30 Giugno: <strong>{selectedGiugno === 1 ? "SI" : "NO"}</strong> {(selectedGiugno === 1 && selectedGiugnoP !== "" ) ? ("( priorità " + selectedGiugnoP + ")") : "" }</Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Turno dal 1 Luglio al 31 Luglio: <strong>{selectedLuglio === 1 ? "SI" : "NO"}</strong> {(selectedLuglio === 1 && selectedLuglioP !== "" ) ? ("( priorità " + selectedLuglioP + ")") : "" }</Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Turno dal 1 Agosto al 31 Agosto: <strong>{selectedAgosto === 1 ? "SI" : "NO"}</strong> {(selectedAgosto === 1 && selectedAgostoP !== "" ) ? ("( priorità " + selectedAgostoP + ")") : "" }</Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Turno dal 1 Settembre al 15 Settembre: <strong>{selectedSettembre === 1 ? "SI" : "NO"}</strong> {(selectedSettembre === 1 && selectedSettembreP !== "" ) ? ("( priorità " + selectedSettembreP + ")") : "" }</Typography>


      <Typography variant="subtitle1"  align='left' paddingTop={2}><strong>ABBONAMENTI PER FAMILIARI E/O CONVIVENTI</strong></Typography>
      <Typography variant="subtitle1"  align='left' paddingTop={0}>Numero richieste abbonamenti oltre il titolare: <strong>{numberOfParents}</strong></Typography>
      {(numberOfParents >= 1) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 1</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA1.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA1.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA1 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA1 !== "") ? (noteEA1.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
      {(numberOfParents >= 2) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 2</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA2.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA2.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA2 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA2 !== "") ? (noteEA2.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
        {(numberOfParents >= 3) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 3</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA3.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA3.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA3 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA3 !== "") ? (noteEA3.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
          {(numberOfParents >=4) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 4</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA4.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA4.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA4 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA4 !== "") ? (noteEA4.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
        {(numberOfParents >=5) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 5</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA5.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA5.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA5 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA5 !== "") ? (noteEA5.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
          {(numberOfParents >=6) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 6</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA6.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA6.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA6 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA6 !== "") ? (noteEA6.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
         {(numberOfParents >=7) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 7</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA7.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA7.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA7 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA7 !== "") ? (noteEA7.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
         {(numberOfParents >=8) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 8</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA8.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA8.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA8 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA8 !== "") ? (noteEA7.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
         {(numberOfParents >=9) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 9</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA9.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA9.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA9 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA9 !== "") ? (noteEA9.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}
        {(numberOfParents >=10) ? (
        <>
        <Typography variant="subtitle1"  align='left' paddingTop={1}><strong>Dati abbonamento 10</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Grado di parentela: <strong>{gradoParentelaEA10.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Nome e cognome: <strong>{nomeCognomeEA10.toUpperCase()}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Età: <strong>{(etaEA10 === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti")}</strong></Typography>
        <Typography variant="subtitle1"  align='left' paddingTop={0}>Note: <strong>{(noteEA10 !== "") ? (noteEA9.toUpperCase()) : ("--")}</strong></Typography>
        </>
        ) : (<></>)}

        <Typography variant="subtitle1"  align='center' paddingTop={3}>Premi il tasto invia per concludere la presentazione della richiesta di abbonamento.</Typography>
      </div>
    } 
  ];

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    //if(activeStep === 1){
    //  return
    //}
    if(activeStep === 6){
      writeToDB();
    }else{
      if(activeStep >= 2){
        if (handleContinue(activeStep) === true){
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      }else{
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
  }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    window.location.reload(); 

  };
  const [messaggioUploaded, setMessaggioUploaded] = React.useState("");
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [listOfFiles, setListOfFiles] = React.useState([]);
  var files = [];

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      console.log(file.name)
      files.push({name:file.name, file:file});
    })
    console.log(files);
    setListOfFiles(files);
  }, [])
  const {getRootProps, getInputProps} = useDropzone({onDrop})
  
  const handleResetListOfFiles = () => {
   files = [];
   setListOfFiles([]);

  };


  const upload = () => {
      handleOpenLoader(true);
      if (listOfFiles.length == 0)
        return;
      let counter = 0;
      listOfFiles.forEach((element) => {
        const storageRef = ref(storage, "/" + userAttachmentsRequestId + "/" + element.name);
        uploadBytes(storageRef, element.file).then((snapshot) => {
          counter += 1;
          console.log(counter);
          if(counter === listOfFiles.length){
            handleCloseLoader();
            files = [];
            setListOfFiles([]);
            setMessaggioUploaded("Tutti i file sono stati caricati con successo!");
          }
        });
      });
       
        
      }

  return (
    <Box  sx={{ flexGrow: 1 }}>
      {(showUploader === false) ? (
         <>
         <Box sx={{ textAlign:"right"}}>
           
           <Button
             variant="contained"
             onClick={handleClickOpenAttachmentsDialog}
             sx={{ mt: 1, mr: 1 }}
             size='small'
           >
           CARICA DOCUMENTAZINE
           </Button>
         </Box>
        <Typography gutterBottom variant="h5" component="div">
          La fase di ricezione delle domande per la Campagna Abbonamenti 2026 è terminata il 25 Giugno 2026. 
        </Typography>
        <Typography gutterBottom variant="h5" component="div">
          Le domande pervenute sono in fase di valutazione.
        </Typography>
        <Typography gutterBottom variant="h5" component="div">
          Se hai ricevuto la mail di approvazione utilizza il pulsante Carica Documentazione per completare il processo di verifica.
        </Typography>
        
         
   </>
      ) : (
        
        <><Box  sx={{ flexGrow: 1 }}>
           <Box sx={{ textAlign:"right"}}>
          
         </Box>
          <Grid><Typography gutterBottom variant="h6" component="div">
                    CARICA I TUOI DOCUMENTI
                  </Typography>
                  <Stack direction="row" spacing={0.5}>
                  <Card variant="outlined" sx={{ width: "100%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      
                      <Box sx={{ p: 2, justifyContent:"center", textAlign:"center"}}>
                        <Stack direction="row" spacing={1}> 
                        <Paper
                          sx={{
                            width: "100%",
                              cursor:'pointer',
                              background:'#fafafa',
                              color:'#bdbdbd',
                              border:'1px dashed #ccc',
                              '&:hover':{border:'1px solid #ccc'}
                          }}>
                            {/*  <Dropzone onDrop={acceptedFiles => console.log(acceptedFiles)} sx={{ width: "100%", justifyContent:"center", textAlign:"center" }}>
                              {({getRootProps, getInputProps}) => (
                                <section  sx={{ width: "100%", justifyContent:"center", textAlign:"center" }}>
                                  <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <p>Trascina i files che vuoi caricare, oppure clicca qui per selezionarli.</p>
                                  </div>
                                </section>
                              )}
                            </Dropzone> */}
                            <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <p>Trascina i files che vuoi caricare, oppure clicca qui per selezionarli.</p>
                                  </div>
                        </Paper>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <List dense={dense}>
                            {listOfFiles.map((item) => (
                              <ListItem>
                                <ListItemText
                                  primary={item.name}
                                />
                              </ListItem>
                            ))}
                            </List>
                        <Typography gutterBottom variant="body2">
                          {messaggioUploaded}
                        </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          
                        </Typography>
                        <Typography gutterBottom variant="h6" component="div">
                        <Button sx={{border:1, marginRight:2}}  onClick={handleResetListOfFiles}>RESET</Button>
                       <Button sx={{border:1, marginRight:2}} onClick={upload}>INVIA</Button>
                       </Typography>
                        </Stack>
                      </Box>
                    </Card>
                  </Stack>
                  <Button
                    variant="contained"
                    onClick={handleClickChiudiUploader}
                    sx={{ mt: 1, mr: 1 }}
                    size='small'
                  >
                  CHIUDI PANNELLO DOCUMENTI
                  </Button>
           </Grid>
        </Box>
        </>
      )}
     
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openLoader}
        onClick={handleCloseLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

       {/* Verifica DOmanda*/}
       <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            //console.log(email);
            handleCloseDialog();
          },
        }}
      >
        <DialogTitle>Verifica Domanda</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Inserisci l'indirizzo email indicato nella richiesta di abbonamento che hai inviato.<br></br>Se nel sistema è presente una richiesta che fa riferimento all'indirizzo di posta elettronica fornito allora riceverai una mail di riepilogo con i dati della tua richiesta. 
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="Indirizzo email"
            type="email"
            fullWidth
            variant="standard"
            value={verificaDomandaField}
            onChange={handleVerificaDomandaFieldChange}
            onBlur={handleVerificaDomandaFieldChange}
            error={verificaDomandaFieldError}
            helperText={verificaDomandaFieldError ? "" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Annulla</Button>
          <Button type="submit" onClick={verificaDomanda}>Invia</Button>
        </DialogActions>
      </Dialog>

        {/* Verifica DOmanda*/}
        <Dialog
        open={openAttachmentsDialog}
        onClose={handleCloseAttachmentsDialog}
       
        
      >
        <DialogTitle>Accedi alla tua area Documenti</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Inserisci l'indirizzo email indicato nella richiesta di abbonamento che hai inviato, il codice richiesta e il codice verifica che hai ricevuto via email.<br></br>

          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="Indirizzo email"
            type="email"
            fullWidth
            variant="standard"
            value={userAttachmentsEmail}
            onChange={handleUserAttachmentsEmailChange}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            name="codicerichiesta"
            label="Codice Richiesta"
            type="codicerichiesta"
            fullWidth
            variant="standard"
            value={userAttachmentsRequestId}
            onChange={handleUserAttachmentsRequestIdChange}
          
          />
          <TextField
            autoFocus
            required
            margin="dense"
            name="codiceverifica"
            label="Codice Verifica"
            type="codiceverifica"
            fullWidth
            variant="standard"
            value={userAttachmentsOTP}
            onChange={handleUserAttachmentsOTPChange}
         
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAttachmentsDialog}>Annulla</Button>
          <Button onClick={verificaAttachmentsDomanda}>Ok</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Form;